module.exports = __webpack_public_path__ + "img/printer.e2926123.svg";